export default "__VITE_ASSET__PuJystrA__"